var _rect, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _path7, _g6, _path8, _path9, _path0, _path1, _path10, _path11, _g7, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighReturn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 68,
    viewBox: "0 0 92 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 67.7895,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1353_31825)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1353_31825",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 37,
    width: 36,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5653 37.6047H80.2319C81.3594 37.6047 82.2734 38.5269 82.2734 39.6644V45.1812C82.2734 46.3187 81.3594 47.2408 80.2319 47.2408H49.5653C48.4378 47.2408 47.5237 46.3187 47.5237 45.1812V39.6644C47.5237 38.5269 48.4378 37.6047 49.5653 37.6047Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1353_31825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.579 37.6049H80.2455C81.3731 37.6049 82.2871 38.527 82.2871 39.6645V45.1813C82.2871 46.3188 81.3731 47.2409 80.2455 47.2409H49.579C48.4514 47.2409 47.5374 46.3188 47.5374 45.1813V39.6645C47.5374 38.527 48.4514 37.6049 49.579 37.6049Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0889 45.1581C83.0889 46.2956 82.1749 47.2178 81.0474 47.2178H56.9316H58.2335C59.3611 47.2178 60.2751 46.2956 60.2751 45.1581V39.6665C60.2751 38.529 59.3611 37.6068 58.2335 37.6068H56.9316H81.0474C82.1749 37.6068 83.0889 38.529 83.0889 39.6665V45.1581Z",
    fill: "#F7993B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4824 45.1806C57.4824 46.318 58.3964 47.2402 59.524 47.2402H93.2555V46.1535H67.4475C66.6959 46.1535 66.0865 45.5388 66.0865 44.7805V40.2131C66.0865 39.4548 66.6959 38.8401 67.4475 38.8401H69.43L59.7341 37.8279C58.5299 37.7022 57.4824 38.6552 57.4824 39.8766V45.1806Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6281 46.1686H70.7324H72.7148C73.4665 46.1686 74.0758 45.5538 74.0758 44.7955V40.2417C74.0758 39.4834 73.4665 38.8686 72.7148 38.8686H70.7324H81.6279H79.8617C79.11 38.8686 78.5007 39.4834 78.5007 40.2417V44.7955C78.5007 45.5538 79.11 46.1686 79.8617 46.1686H81.6281Z",
    fill: "#FFD79B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0195 45.1898C49.0195 46.3274 49.9336 47.2495 51.0611 47.2495L84.7922 47.2495V46.1628H58.9847C58.233 46.1628 57.6237 45.5481 57.6237 44.7897V40.0641C57.6237 39.3058 58.233 38.691 58.9847 38.691H60.9672H49.0195V45.1898Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6548 38.8604H45.2734V37.3639H82.1138L83.6548 38.8604Z",
    fill: "#FFD79B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1353_31825",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 29,
    width: 35,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2059 29.0332H78.8725C80 29.0332 80.9141 29.9553 80.9141 31.0928V36.6096C80.9141 37.7471 80 38.6693 78.8725 38.6693H48.2059C47.0784 38.6693 46.1643 37.7471 46.1643 36.6096V31.0928C46.1643 29.9553 47.0784 29.0332 48.2059 29.0332Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1353_31825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2196 29.0332H78.8862C80.0137 29.0332 80.9277 29.9553 80.9277 31.0928V36.6096C80.9277 37.7471 80.0137 38.6693 78.8862 38.6693H48.2196C47.0921 38.6693 46.178 37.7471 46.178 36.6096V31.0928C46.178 29.9553 47.0921 29.0332 48.2196 29.0332Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7316 36.5874C81.7316 37.7249 80.8175 38.6471 79.6899 38.6471H55.5742H56.8761C58.0036 38.6471 58.9177 37.7249 58.9177 36.5874V31.0958C58.9177 29.9583 58.0036 29.0362 56.8761 29.0362H55.5742H79.6899C80.8175 29.0362 81.7316 29.9583 81.7316 31.0958V36.5874Z",
    fill: "#F7993B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8125 36.6219C51.8125 37.7595 52.7266 38.6816 53.8542 38.6816H87.5853V37.595H61.7777C61.0261 37.595 60.4167 36.9802 60.4167 36.2218V31.6545C60.4167 30.8962 61.0261 30.2814 61.7777 30.2814H63.7602L54.0643 29.2693C52.86 29.1435 51.8125 30.0966 51.8125 31.3179V36.6219Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9309 37.7319H55.0352H57.0176C57.7693 37.7319 58.3787 37.1172 58.3787 36.3588V31.805C58.3787 31.0468 57.7693 30.4319 57.0176 30.4319H55.0352H65.9306H64.1646C63.4128 30.4319 62.8034 31.0468 62.8034 31.805V36.3588C62.8034 37.1172 63.4128 37.7319 64.1646 37.7319H65.9309Z",
    fill: "#FFD79B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5449 36.6219C45.5449 37.7595 46.459 38.6816 47.5865 38.6816H81.3176V37.595H55.5101C54.7584 37.595 54.1491 36.9802 54.1491 36.2218V31.4963C54.1491 30.7379 54.7584 30.1231 55.5101 30.1231H57.4926H45.5449V36.6219Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2915 30.2894H43.9102V28.793H80.7505L82.2915 30.2894Z",
    fill: "#FFD79B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1353_31825",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 47,
    width: 36,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6258 47.2405H84.2924C85.4199 47.2405 86.334 48.1627 86.334 49.3002V54.817C86.334 55.9545 85.4199 56.8766 84.2924 56.8766H53.6258C52.4983 56.8766 51.5843 55.9545 51.5843 54.817V49.3002C51.5843 48.1627 52.4983 47.2405 53.6258 47.2405Z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1353_31825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.6376 47.2405H84.3041C85.4317 47.2405 86.3457 48.1627 86.3457 49.3002V54.817C86.3457 55.9545 85.4317 56.8766 84.3041 56.8766H53.6376C52.51 56.8766 51.596 55.9545 51.596 54.817V49.3002C51.596 48.1627 52.51 47.2405 53.6376 47.2405Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1496 54.7933C87.1496 55.9307 86.2355 56.8529 85.1079 56.8529H60.9922H62.2941C63.4216 56.8529 64.3357 55.9307 64.3357 54.7933V49.3016C64.3357 48.1641 63.4216 47.242 62.2941 47.242H60.9922H85.1079C86.2355 47.242 87.1496 48.1641 87.1496 49.3016V54.7933Z",
    fill: "#F7993B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4707 54.8163C56.4707 55.9538 57.3847 56.8759 58.5123 56.8759L92.2432 56.876V55.7892H66.4358C65.6842 55.7892 65.0748 55.1745 65.0748 54.4162V49.8488C65.0748 49.0905 65.6842 48.4757 66.4358 48.4757H68.4183L58.7224 47.4635C57.5181 47.3379 56.4707 48.2909 56.4707 49.5123V54.8163Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.048 55.7087H67.1523H69.1347C69.8864 55.7087 70.4958 55.0939 70.4958 54.3356V49.7818C70.4958 49.0235 69.8864 48.4088 69.1347 48.4088H67.1523H78.0477H76.2817C75.5299 48.4088 74.9206 49.0235 74.9206 49.7818V54.3356C74.9206 55.0939 75.5299 55.7087 76.2817 55.7087H78.048Z",
    fill: "#FFD79B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9648 54.8292C50.9648 55.9668 51.8789 56.8889 53.0064 56.8889L86.7375 56.889V55.8022H60.9301C60.1784 55.8022 59.569 55.1875 59.569 54.4291V49.7035C59.569 48.9453 60.1784 48.3304 60.9301 48.3304H62.9125H50.9648V54.8292Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7134 48.496H49.332V46.9996H86.1724L87.7134 48.496Z",
    fill: "#FFD79B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1353_31825",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 20,
    width: 36,
    height: 10
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8934 20.2929H82.56C83.6875 20.2929 84.6016 21.215 84.6016 22.3525V27.8693C84.6016 29.0068 83.6875 29.929 82.56 29.929H51.8934C50.7659 29.929 49.8518 29.0068 49.8518 27.8693V22.3525C49.8518 21.215 50.7659 20.2929 51.8934 20.2929Z",
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1353_31825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9051 20.2929H82.5717C83.6992 20.2929 84.6133 21.215 84.6133 22.3525V27.8693C84.6133 29.0068 83.6992 29.929 82.5717 29.929H51.9051C50.7776 29.929 49.8636 29.0068 49.8636 27.8693V22.3525C49.8636 21.215 50.7776 20.2929 51.9051 20.2929Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4211 27.8456C85.4211 28.9832 84.507 29.9052 83.3795 29.9052H59.2637H60.5656C61.6931 29.9052 62.6072 28.9832 62.6072 27.8456V22.354C62.6072 21.2165 61.6931 20.2944 60.5656 20.2944H59.2637H83.3795C84.507 20.2944 85.4211 21.2165 85.4211 22.354V27.8456Z",
    fill: "#F7993B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7363 27.8686C54.7363 29.0061 55.6503 29.9282 56.7779 29.9283H90.5089V28.8415H64.7014C63.9498 28.8415 63.3404 28.2268 63.3404 27.4685V22.9011C63.3404 22.1428 63.9498 21.528 64.7014 21.528H66.6839L56.988 20.5159C55.7838 20.3902 54.7363 21.3432 54.7363 22.5646V27.8686Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3175 28.7611H65.4219H67.4042C68.156 28.7611 68.7653 28.1463 68.7653 27.388V22.8343C68.7653 22.0759 68.156 21.4612 67.4042 21.4612H65.4219H76.3173H74.5512C73.7995 21.4612 73.1901 22.0759 73.1901 22.8343V27.388C73.1901 28.1463 73.7995 28.7611 74.5512 28.7611H76.3175Z",
    fill: "#FFD79B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2363 27.8802C49.2363 29.0177 50.1504 29.9398 51.2779 29.9398L85.009 29.9399V28.8531H59.2015C58.4498 28.8531 57.8405 28.2384 57.8405 27.48V22.7544C57.8405 21.9961 58.4498 21.3813 59.2015 21.3813H61.1839H49.2363V27.8802Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9829 21.5484H47.6016V20.0519H84.442L85.9829 21.5484Z",
    fill: "#FFD79B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1353_31825",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 56,
    width: 36,
    height: 11
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4715 56.8772H77.1381C78.2656 56.8772 79.1797 57.7993 79.1797 58.9368V64.4536C79.1797 65.5911 78.2656 66.5133 77.1381 66.5133H46.4715C45.344 66.5133 44.43 65.5911 44.43 64.4536V58.9368C44.43 57.7993 45.344 56.8772 46.4715 56.8772Z",
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1353_31825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4852 56.8772H77.1518C78.2793 56.8772 79.1934 57.7993 79.1934 58.9368V64.4536C79.1934 65.5911 78.2793 66.5133 77.1518 66.5133H46.4852C45.3577 66.5133 44.4436 65.5911 44.4436 64.4536V58.9368C44.4436 57.7993 45.3577 56.8772 46.4852 56.8772Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0011 64.4299C80.0011 65.5674 79.087 66.4895 77.9595 66.4895H53.8438H55.1457C56.2732 66.4895 57.1872 65.5674 57.1872 64.4299V58.9383C57.1872 57.8007 56.2732 56.8787 55.1457 56.8787H53.8438H77.9595C79.087 56.8787 80.0011 57.8007 80.0011 58.9383V64.4299Z",
    fill: "#F7993B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.082 64.4649C50.082 65.6023 50.9961 66.5245 52.1237 66.5245H85.8548V65.4379H60.0472C59.2956 65.4379 58.6862 64.823 58.6862 64.0648V59.4974C58.6862 58.7391 59.2956 58.1244 60.0472 58.1244H62.0297L52.3338 57.1122C51.1296 56.9865 50.082 57.9395 50.082 59.1609V64.4649Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0989 65.3454H59.2031H61.1856C61.9372 65.3454 62.5466 64.7307 62.5466 63.9724V59.4185C62.5466 58.6603 61.9372 58.0455 61.1856 58.0455H59.2031H70.0986H68.3324C67.5808 58.0455 66.9714 58.6603 66.9714 59.4185V63.9724C66.9714 64.7307 67.5808 65.3454 68.3324 65.3454H70.0989Z",
    fill: "#FFD79B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8145 64.4644C43.8145 65.6019 44.7285 66.5241 45.856 66.5241H79.5872V65.4374H53.7797C53.0279 65.4374 52.4186 64.8226 52.4186 64.0643V59.3387C52.4186 58.5804 53.0279 57.9656 53.7797 57.9656H55.762H43.8145V64.4644Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.561 58.1327H42.1797V56.6362H79.0201L80.561 58.1327Z",
    fill: "#FFD79B"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9182 57.7259C31.4265 59.5315 36.4446 60.2679 41.2323 57.0552C48.8986 51.9625 52.2582 40.9989 48.7534 32.52C46.7374 27.6741 40.7328 24.5398 35.9653 22.8309L23.3809 56.7866L25.9182 57.7259Z",
    fill: "#7E3E30"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1353_31825",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 22,
    width: 28,
    height: 38
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9279 57.7304C31.4361 59.536 36.4543 60.2724 41.2419 57.0597C48.9084 51.967 52.268 41.0033 48.7631 32.5245C46.747 27.6785 40.7425 24.5442 35.9751 22.8353L23.3906 56.7911L25.9279 57.7304Z",
    fill: "#7E3E30"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1353_31825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8154 36.9138C26.0306 28.1661 30.4162 18.9224 38.6109 16.2674C46.8055 13.6123 55.7061 18.5514 58.4909 27.299C61.2757 36.0466 56.8901 45.2903 48.6955 47.9454C40.5008 50.6004 31.6002 45.6614 28.8154 36.9138Z",
    fill: "#D1674F"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5678 54.9251C27.9014 60.0179 18.8131 57.266 15.3331 48.7652C11.853 40.2645 15.2373 29.279 22.9255 24.2113C30.5888 19.1654 39.6306 21.9142 43.1355 30.3931C46.6403 38.8719 43.2807 49.8355 35.6144 54.9283L35.5678 54.9251Z",
    fill: "#FFC165"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3229 51.2269C30.5898 53.0226 27.5897 53.5519 24.8899 52.7116C22.2365 51.8744 20.1314 49.802 18.9218 46.8944C17.6345 43.7461 17.5311 39.9941 18.6551 36.3948C19.7575 32.7704 21.9664 29.7149 24.8452 27.8348C27.5784 26.0392 30.5784 25.5099 33.3 26.3751C35.9533 27.2123 38.0367 29.2597 39.2681 32.1923C40.5553 35.3406 40.6618 39.0458 39.5595 42.6701C38.4572 46.2944 36.2482 49.35 33.3911 51.2551L33.3229 51.2269Z",
    fill: "#FFE0B2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2971 45.5647L25.207 39.4612L27.0454 40.1551C28.8171 40.7352 30.9204 40.4066 31.8179 38.2452C32.2531 37.186 32.9686 34.6676 30.2591 33.645",
    strokeWidth: 1.03326,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F7993B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0547 35.7234L33.8592 38.669",
    strokeWidth: 1.03326,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F7993B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4883 32.5967L35.3569 35.566",
    strokeWidth: 1.03326,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F7993B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1353_31825",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 56,
    width: 35,
    height: 11
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7667 56.8794H12.1002C10.9726 56.8794 10.0586 57.8015 10.0586 58.939V64.4558C10.0586 65.5933 10.9726 66.5155 12.1002 66.5155H42.7667C43.8943 66.5155 44.8083 65.5933 44.8083 64.4558V58.939C44.8083 57.8015 43.8943 56.8794 42.7667 56.8794Z",
    fill: "#D9D9D9"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1353_31825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7667 56.8794H12.1002C10.9726 56.8794 10.0586 57.8015 10.0586 58.939V64.4558C10.0586 65.5933 10.9726 66.5155 12.1002 66.5155H42.7667C43.8943 66.5155 44.8083 65.5933 44.8083 64.4558V58.939C44.8083 57.8015 43.8943 56.8794 42.7667 56.8794Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24805 64.4328C9.24805 65.5704 10.1621 66.4925 11.2896 66.4925H35.4054H34.1035C32.976 66.4925 32.0619 65.5704 32.0619 64.4328V58.9412C32.0619 57.8038 32.976 56.8816 34.1035 56.8816H35.4054H11.2896C10.1621 56.8816 9.24805 57.8038 9.24805 58.9412V64.4328Z",
    fill: "#F7993B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1731 64.4667C39.1731 65.6042 38.2591 66.5263 37.1315 66.5263L3.40039 66.5264V65.4397H29.2079C29.9596 65.4397 30.569 64.825 30.569 64.0666V59.4993C30.569 58.741 29.9596 58.1262 29.2079 58.1262H27.2255L36.9214 57.1141C38.1256 56.9883 39.1731 57.9414 39.1731 59.1627V64.4667Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7285 65.4423H21.6242H19.6418C18.8901 65.4423 18.2807 64.8276 18.2807 64.0692V59.5155C18.2807 58.7571 18.8901 58.1424 19.6418 58.1424H21.6242H10.7287H12.4949C13.2466 58.1424 13.8559 58.7571 13.8559 59.5155V64.0692C13.8559 64.8276 13.2466 65.4423 12.4949 65.4423H10.7285Z",
    fill: "#FFD79B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4407 64.4666C45.4407 65.6042 44.5266 66.5263 43.3991 66.5263L9.66797 66.5263V65.4396H35.4755C36.2272 65.4396 36.8365 64.8249 36.8365 64.0665V59.3409C36.8365 58.5826 36.2272 57.9678 35.4755 57.9678H33.493H45.4407V64.4666Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6875 58.135H47.0688V56.6384H10.2284L8.6875 58.135Z",
    fill: "#FFD79B"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2579 16.6972L34.3235 12.7432C34.4089 12.4209 34.743 12.2215 35.0689 12.2877C46.9963 14.7907 55.5761 7.21599 57.4964 5.3255C57.7317 5.0921 58.0966 5.08186 58.3367 5.28829L61.3914 7.9349C61.6594 8.15863 61.6712 8.56802 61.4211 8.81931C59.1476 11.1294 48.681 20.6346 33.7156 17.4365C33.382 17.3578 33.1725 17.0195 33.2602 16.687L33.2579 16.6972Z",
    fill: "#6AC8A9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6547 2.62152L54.3267 2.92481C53.8863 2.93865 53.6427 3.43762 53.9051 3.77773L61.3788 13.3519C61.6412 13.6921 62.1907 13.5756 62.3097 13.1542L65.1663 3.26652C65.2665 2.92633 65.0119 2.59876 64.6571 2.61138L64.6547 2.62152Z",
    fill: "#6AC8A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1353_31825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.3326,
    height: 66.9299,
    fill: "white",
    transform: "translate(5.36914)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighReturn);
export default __webpack_public_path__ + "static/media/high-return.c24fa900d17e207129aeca99c2b322b4.svg";
export { ForwardRef as ReactComponent };